import { Amplify } from 'aws-amplify';
import { signIn, signOut, fetchAuthSession } from 'aws-amplify/auth';

// ==============================|| AMPLIFY CONFIG ||============================== //

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID
    }
  }
});

// ==============================|| LOCAL STORAGE KEYS ||============================== //

const TOKEN_KEYS = {
  ACCESS: 'access_token',
  ID: 'id_token'
} as const;

// ==============================|| AUTH FUNCTIONS ||============================== //

export async function loginAdmin(email: string, password: string) {
  // Clear any stale session first
  try {
    const existing = await fetchAuthSession();
    if (existing.tokens) {
      await signOut();
    }
  } catch (_) {}

  const { nextStep } = await signIn({ username: email, password });

  if (nextStep.signInStep !== 'DONE') {
    throw new Error(`Unexpected sign-in step: ${nextStep.signInStep}`);
  }

  const session = await fetchAuthSession();
  const accessToken = session.tokens?.accessToken?.toString() || '';
  const idToken = session.tokens?.idToken?.toString() || '';

  localStorage.setItem(TOKEN_KEYS.ACCESS, accessToken);
  localStorage.setItem(TOKEN_KEYS.ID, idToken);

  return { accessToken, idToken };
}

export function getStoredToken(): string | null {
  return localStorage.getItem(TOKEN_KEYS.ACCESS);
}

export async function logoutAdmin(): Promise<void> {
  try {
    await signOut();
  } catch (_) {}
  localStorage.removeItem(TOKEN_KEYS.ACCESS);
  localStorage.removeItem(TOKEN_KEYS.ID);
  window.location.href = '/login';
}

export function isAuthenticated(): boolean {
  const token = localStorage.getItem(TOKEN_KEYS.ACCESS);
  return token !== null && token.length > 0;
}

export async function refreshSession(): Promise<string | null> {
  try {
    const session = await fetchAuthSession({ forceRefresh: true });
    const accessToken = session.tokens?.accessToken?.toString() || '';
    const idToken = session.tokens?.idToken?.toString() || '';

    localStorage.setItem(TOKEN_KEYS.ACCESS, accessToken);
    localStorage.setItem(TOKEN_KEYS.ID, idToken);

    return accessToken;
  } catch (_) {
    localStorage.removeItem(TOKEN_KEYS.ACCESS);
    localStorage.removeItem(TOKEN_KEYS.ID);
    return null;
  }
}
